import Reflux from "reflux";

import { callWebUtils } from "./helpers";

const INIT = {
  clear: {},
  getCampaignMembers: { asyncResult: true },
  updateCampaignMembers: { asyncResult: true }
};

const Actions = Reflux.createActions(INIT);

Actions.getCampaignMembers.listen(function (campaignId) {
  return callWebUtils(this, "getCampaignMembers", [campaignId]);
});

Actions.updateCampaignMembers.listen(function (
  campaignId,
  campaignMembers,
  addedSubscribersAts,
  addedSubscribersCampaign
) {
  return callWebUtils(this, "updateCampaignMembers", [
    campaignId,
    { memberUpdates: campaignMembers, byUser: true, addedSubscribersAts, addedSubscribersCampaign }
  ]);
});

export default Actions;
